import { FlexPosition, Global, ResponsiveSize } from 'src/components/Globals/Globals';
import styled from 'styled-components';

enum FlexDirection {
  row,
  column
}

enum FlexWrap {
  nowrap,
  wrap
}

interface IFlexInterface {
  direction?: FlexDirection;
  columns?: number;
  alignHorizontal?: FlexPosition;
  alignVertical?: FlexPosition;
  tileAfter?: ResponsiveSize;
  flexSize?: number;
  baseMargin?: boolean;
  wrap?: FlexWrap;
  margin?: string;
}

const Flex = styled.div<IFlexInterface>`
  display: flex;
  flex: ${props => props.flexSize || 1};
  flex-direction: ${props => FlexDirection[props.direction || FlexDirection.row]};
  justify-content: ${props => props.alignHorizontal || FlexPosition.left};
  align-items: ${props => props.alignVertical || FlexPosition.stretch};
  flex-wrap: ${props => FlexWrap[props.wrap || FlexWrap.nowrap]};
  margin: ${props => `${props.margin || `0 ${props.baseMargin ? Global.baseMargin.M.x : '0'}`}`};

  ${props =>
    props.tileAfter &&
    `@media (max-width: ${props.tileAfter}) {
      flex-direction: column;
      justify-content: flex-start;
    }`}

  @media (max-width: ${ResponsiveSize.tablet}) {
    margin: 0 ${props => (props.baseMargin ? Global.baseMargin.S.x : '0')};
  }
`;

export { Flex, FlexDirection, FlexWrap };



// WEBPACK FOOTER //
// ./src/components/Flex/Flex.tsx